module.exports = __webpack_public_path__ + "static/media/angel-right.105ff3bc.svg";